module.exports = __webpack_public_path__ + "img/Calum Chambers.a16758b1.png";